import { observer } from 'mobx-react-lite';

import DevPanel from 'devtools/DevPanel';
import personalTimelineStore from 'pages/CrewMemberDetails/components/PersonalTimeline/PersonalTimelineStore';

import styles from './styles.module.css';

const MockDataToggle = observer(() => {
	const { useMockData, setUseMockData } = personalTimelineStore;

	return (
		<DevPanel title="Test data">
			<label className={styles.label}>
				<input
					type="checkbox"
					checked={useMockData}
					onChange={(e) => setUseMockData(e.target.checked)}
				/>
				Use mock data
			</label>
		</DevPanel>
	);
});

export default MockDataToggle;
